import { RateSheetGeneratorEditor } from 'RtUi/app/AccountManagement/RateSheetGenerator/libs/forms/RateSheetGeneratorEditor';
import { useGetRateSheetGenerator } from 'RtUi/app/AccountManagement/RateSheetGenerator/libs/services';
import { RateSheetGeneratorRouter } from 'RtUi/app/AccountManagement/RateSheetGenerator/RateSheetGenerator.router';
import { useIdParam } from 'RtUi/components/hooks/useIdParam';
import { Loading } from 'RtUi/components/ui/Loading';
import { StandardLayout } from 'RtUi/components/ui/StandardLayout';
import { useTabs } from 'RtUi/components/ui/TabbedLayout/useTabs';

export const RateSheetGeneratorProfileContainer = (): JSX.Element => {
	const rateSheetGeneratorId = useIdParam();
	const { data, isLoading, refetch } = useGetRateSheetGenerator(
		Number(rateSheetGeneratorId)
	);

	const [tabs, activeTab, setActiveTab] = useTabs(
		RateSheetGeneratorRouter.getProfileTabs()
	);

	if (isLoading) {
		return <Loading />;
	}

	if (!data) {
		return <p>Something went wrong!</p>;
	}

	return (
		<StandardLayout profile={data} router={RateSheetGeneratorRouter}>
			<RateSheetGeneratorEditor
				displayModes={true}
				editMode={data}
				onUpdate={(newProfile) => refetch()}
			/>
		</StandardLayout>
	);
};

RateSheetGeneratorProfileContainer.displayName =
	'RateSheetGeneratorProfileContainer';

RateSheetGeneratorRouter.setProfileRtUiFunctionalComponent(
	RateSheetGeneratorProfileContainer
);
